export type User = {
    id: number;
    first_name: string;
    last_name: string;
    full_name: string;
    email: string;
    teams: Team[];
    is_admin: boolean;
    active_team_plan?: SubscriptionPlan;
    active_individual_plan?: SubscriptionPlan;
    subscription_plan?: SubscriptionPlan;
    is_individual: boolean;
    features: { [key: string]: string };
};

export type SubscriptionPlan = {
    tier: Tier;
    active: boolean;
    in_free_trial_period: boolean;
    start_date: string;
    end_date: string;
    trial_start_date: string;
    trial_end_date: string;
    id: number;
    cancel_at_period_end: boolean;
    team_limit: number;
    is_team_plan: boolean;
    managed_by_stripe: boolean;
    stripe_subscription_id?: string;
};

export enum Tier {
    BASIC_INDIVIDUAL = 'BASIC_INDIVIDUAL',
    ADVANCED_INDIVIDUAL = 'ADVANCED_INDIVIDUAL',
    MASTER_INDIVIDUAL = 'MASTER_INDIVIDUAL',
    BASIC_TEAM = 'BASIC_TEAM',
    ADVANCED_TEAM = 'ADVANCED_TEAM',
    MASTER_TEAM = 'MASTER_TEAM',
}

export type UserAccess = 'admin' | 'member';
export function getAccessLabel(data: UserAccess) {
    return {
        admin: 'Admin',
        member: 'Member',
    }[data];
}

export type UserTeam = {
    user_id: number;
    team_id: number;
    user_access: UserAccess;
};

export type Team = {
    id: number;
    name: string;
    user_teams: UserTeam[];
    users: User[];
    logo: string;
};

// TODO:

// 1. Admin page to managem subscriptions and offer free trials
// 2. Allow subscriber to create a team and invite users - might need a team limit override?
